import {
	ActionButtonsStateActions,
	SET_ACTION_BUTTONS_VISIBLE,
	SET_SHOW_MEASUREMENTS,
	SET_SHOW_FUNCTION_SLEEP,
	SET_SHOW_FUNCTION_STORAGE,
	SET_SHOW_FUNCTIONS,
	SET_SHOW_SELECT_ALL,
	SET_ROTATION_BUTTON_CLICKED,
} from './types';

export function setActionButtonsVisible(value: boolean): ActionButtonsStateActions {
	return {
		type: SET_ACTION_BUTTONS_VISIBLE,
		value,
	};
}

export function setShowFunctionSleep(value: boolean, track: boolean): ActionButtonsStateActions {
	return {
		type: SET_SHOW_FUNCTION_SLEEP,
		value,
		track,
	};
}

export function setShowFunctionStorage(value: boolean, track: boolean): ActionButtonsStateActions {
	return {
		type: SET_SHOW_FUNCTION_STORAGE,
		value,
		track,
	};
}

export function setShowFunctions(value: boolean): ActionButtonsStateActions {
	return {
		type: SET_SHOW_FUNCTIONS,
		value,
	};
}

export function setShowMeasurements(value: boolean, track: boolean): ActionButtonsStateActions {
	return {
		type: SET_SHOW_MEASUREMENTS,
		value,
		track,
	};
}

export function setShowSelectAll(value: boolean): ActionButtonsStateActions {
	return {
		type: SET_SHOW_SELECT_ALL,
		value,
	};
}

export function setRotationButtonClicked(value: boolean): ActionButtonsStateActions {
	return {
		type: SET_ROTATION_BUTTON_CLICKED,
		value,
	};
}
